<template>
    <div
        class="d-flex flex-column font-12"
        data-placement="top"
        data-toggle="tooltip"
        :title="available.length === 0 && store.contents.unavailableTooltip"
        :class="{
            'cursor-not-allowed': available.length === 0
        }"
    >
        <div class="w-100 font-weight-bold font-15">
            {{ filter.label }}
        </div>
        <div class="d-flex justify-content-between mt-3">
            <div>{{ minLabel || '-' }}</div>
            <div>{{ maxLabel || '-' }}</div>
        </div>
        <div class="mt-1">
            <Slider :min="min" :max="max" :value="value" :disabled="disabled" @change="change" @slide="slide"></Slider>
        </div>
        <div class="w-100 text-center">{{ label || '-' }}</div>
    </div>
</template>

<script>
// components
import Slider from '@se/components/slider/slider.vue'

export default {
    components: {
        // components
        Slider
    },
    props: {
        store: Object,
        filter: Object
    },
    data() {
        return {
            data: {},
            off: [],
            state: {
                highlightIndex: null
            }
        }
    },
    computed: {
        se() {
            return this.store.libs.se
        },
        available() {
            this.store.state.updateCounters // keep this statement to trigger recalculation
            return this.filter.items.filter((item) => {
                return this.se.isAvailable(item.isAvailable) === true
            })
        },
        min() {
            return 0
        },
        max() {
            return !this.disabled ? this.available.length - 1 : 0
        },
        disabled() {
            return this.available.length === 0
        },
        value() {
            this.store.state.updateCounters // keep this statement to trigger recalculation
            this.store.state.updateFilters // keep this statement to trigger recalculation
            if (this.disabled) {
                return -1
            }
            let selected = -1
            this.available.find((item, index) => {
                const criterias = item.criterias ? item.criterias.length : 0
                const values = item.values ? item.values.length : 0
                const _selected = this.se.isSelected(item) === true
                if (!_selected) {
                    if (selected > -1) {
                        return true
                    }
                } else {
                    // if(selected > -1 && item.isDefault){ // if selected the one before the last with no items
                    // 	return true;
                    // }
                    selected = index
                }
            })
            if (selected === -1 && this.available.length > 0) {
                selected = this.available.length - 1
            }
            return selected
        },
        minLabel() {
            if (this.disabled) {
                return null
            }
            return this.available[0].label
        },
        maxLabel() {
            if (this.disabled) {
                return null
            }
            return this.available.slice(-1)[0].label
        },
        label() {
            if (this.disabled || this.value === -1) {
                return null
            }
            return this.filter.items[this.state.highlightIndex !== null ? this.state.highlightIndex : this.value].label
        }
    },
    methods: {
        clear() {
            const values = this.filter.items.flatMap(({ values = [] }) => values)
            const criterias = this.filter.items.flatMap(({ criterias = [] }) => criterias)
            this.se.remove({ values, criterias })
        },
        change(index) {
            this.state.highlightIndex = null
            this.se.batch(() => {
                this.clear()
                const available = this.se.getAvailable(this.available[index])
                this.se.add(available)
            })
        },
        slide(index) {
            this.state.highlightIndex = index
        }
    },
    beforeDestroy() {
        this.off.forEach((off) => off())
    },
    mounted() {}
}
</script>
